// RoommateEntryPage.js
import React from "react";
import { motion } from "framer-motion";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";

// Components
import HeroSection from "../../components/roommate-entry/components/HeroSection/HeroSection";
import UserStoriesSection from "../../components/roommate-entry/components/UserStoriesSection/UserStoriesSection";
import StepsSection from "../../components/roommate-entry/components/StepsSection/StepsSection";
import CTASection from "../../components/roommate-entry/components/CTASection/CTASection";
import AnimatedBackground from "../../components/roommate-entry/components/AnimatedBackground/AnimatedBackground";
import Footer from "../../components/roommate-entry/components/Footer/Footer";

const RoommateEntryPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #000814 0%, #001d3d 50%, #003566 100%)",
        position: "relative",
        overflowX: "hidden",
        overflowY: "auto",
      }}
    >
      {/* Animated Background */}
      <AnimatedBackground />

      {/* Main Content */}
      <Box sx={{ position: "relative", zIndex: 2, }}>
        <HeroSection isMobile={isMobile} navigate={navigate} />
        <UserStoriesSection isMobile={isMobile} />
        <StepsSection isMobile={isMobile} />
        <CTASection isMobile={isMobile} navigate={navigate} />
        <Footer />
      </Box>
    </Box>
  );
};

export default RoommateEntryPage;